import axios from 'axios';

import { AdresseIP } from './AdresseIp';

export class CiteService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite')
                    .then(res => res.data);
    }
    create(newCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite'
        return axios.post(url,newCite)
                    .then(res => res.data);
    }
    update(idCite ,newCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.put(url+idCite, newCite)
                    .then(res => res.data);
    }
    delete(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.patch(url+idCite)
                    .then(res => res.data)
    }
    get(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.get(url+idCite)
                    .then(res => res.data)
    }
    getCategorieChambre(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite-categorie/'
        return axios.get(url+idCite)
                    .then(res => res.data)
    }

    /*
     * Catégories de chambre d'une cité, quelle que soit la forme de la réponse.
     * /cite-categorie/{idCite} renvoie selon les cas { listeCategorieChambre: [...] },
     * une autre clé, ou la liste directement. Si rien n'en sort, on retombe sur la
     * liste complète des catégories filtrée par cité (idCite ou nomCite, car toutes
     * les réponses ne portent pas l'idCite).
     */
    getCategorieChambreCite(idCite, nomCite) {
        return this.getCategorieChambre(idCite)
            .then(data => this.extraireCategories(data))
            .then(liste => liste.length ? liste : this.getCategoriesParCite(idCite, nomCite))
            .catch(error => {
                console.log(error)
                return this.getCategoriesParCite(idCite, nomCite)
            })
    }
    extraireCategories(data) {
        if (Array.isArray(data)) return data;
        if (!data) return [];
        if (Array.isArray(data.listeCategorieChambre)) return data.listeCategorieChambre;
        if (Array.isArray(data.categorieChambres)) return data.categorieChambres;
        if (Array.isArray(data.categories)) return data.categories;
        return [];
    }
    getCategoriesParCite(idCite, nomCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/categorie-chambre'
        return axios.get(url)
                    .then(res => {
                        const liste = Array.isArray(res.data) ? res.data : [];
                        return liste.filter(categorie =>
                            categorie.idCite === idCite || (nomCite && categorie.nomCite === nomCite)
                        );
                    })
    }

    getCitesVille(idVille){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite-ville/'
        return axios.get(url+idVille)
                    .then(res => res.data)
    }
    

}